import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import RelationName from '@/shared/components/RelationName';
import FormattedListValue from '@/shared/components/FormattedListValue';
import DataCacheService from '@/shared/services/DataCacheService';
import EditableCurrency from '@/shared/components/editable/EditableCurrency';
import authService, { privileges } from '@/shared/services/AuthService';
import { mapInvoiceStreamName } from '@/shared/services/ObjectDisplayService';
import EditableSelect from '@/shared/components/editable/EditableSelect';
import messages from './invoiceStreamMessages';
import Checkbox from '../../../shared/components/input/Checkbox';
import { CanRead } from '../../../shared/components/security';

const InvoiceStreamRow = ({
  invoiceStream,
  intl,
  handleSelect,
  onUpdateAmount,
  showAssignments,
  priceGrids,
  onUpdatePriceGrid,
  invoiceDialogsSvc,
}) => {
  const canUpdateRelation = authService.hasPermission({
    functionality: 'relation',
    privilege: privileges.Update,
  });
  return (
    <tbody className="hover" key={invoiceStream.id}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(invoiceStream)} value={invoiceStream.selected} />
        </td>
        <td>
          <RelationName tabIndex={-1} relation={invoiceStream.relation} />
        </td>
        {showAssignments && <td>{mapInvoiceStreamName(invoiceStream, intl)}</td>}

        {invoiceStream.viaRelation ? (
          <td>
            <span className="margin5R">
              <FormattedMessage {...messages.InvoicingVia} />
            </span>
            &nbsp;
            <RelationName
              tabIndex={-1}
              relation={invoiceStream.viaRelation}
              assignment={showAssignments ? invoiceStream.viaRelation : null}
            />
          </td>
        ) : (
          <td>
            {invoiceStream.invoiceScheduleId ? (
              <FormattedListValue
                id={invoiceStream.invoiceScheduleId}
                list="invoiceschedule"
                fallback={invoiceStream.invoiceScheduleName}
              />
            ) : (
              <FormattedMessage {...messages.NoInvoiceSchedule} />
            )}
          </td>
        )}
        <td>
          {(invoiceStream.invoicingType === 1 || invoiceStream.invoicingType === 2) && (
            <EditableCurrency
              value={invoiceStream.amount}
              onChange={val => onUpdateAmount({ ...invoiceStream, amount: val })}
              readOnly={!canUpdateRelation}
            />
          )}
        </td>
        <td>
          {invoiceStream.invoicingType === 1 &&
            (invoiceStream.fixedAmountRegistrationMethod !== null ? (
              <FormattedListValue
                id={invoiceStream.fixedAmountRegistrationMethod}
                list="fixedAmountRegistrationMethod"
              />
            ) : (
              <FormattedListValue
                id={
                  DataCacheService.getCompanySettings(invoiceStream.companyId)
                    .fixedAmountRegistrationMethod
                }
                list="fixedAmountRegistrationMethod"
              />
            ))}
        </td>
        <td>
          {invoiceStream.invoicingType === 2 &&
            (invoiceStream.advanceRegistrationMethod !== null ? (
              <FormattedListValue
                id={invoiceStream.advanceRegistrationMethod}
                list="advanceRegistrationMethod"
              />
            ) : (
              <FormattedListValue
                id={
                  DataCacheService.getCompanySettings(invoiceStream.companyId)
                    .advanceRegistrationMethod
                }
                list="advanceRegistrationMethod"
              />
            ))}
        </td>
        <td>
          <EditableSelect
            value={`${invoiceStream.priceGridId}`}
            onChange={priceGridId => onUpdatePriceGrid(priceGridId)}
            displayValue={
              invoiceStream.priceGrid === 'Default'
                ? intl.formatMessage(messages.Default)
                : invoiceStream.priceGrid
            }
            options={priceGrids}
            bindToId
            required
            readOnly={!canUpdateRelation}
            class="form-control input-sm"
          />
        </td>
        <td>
          <CanRead on="InvoiceDraft">
            <a
              className="btn btn-sm btn-icon"
              onClick={() =>
                invoiceDialogsSvc.showInvoicingHistory(
                  invoiceStream.id,
                  null,
                  invoiceStream.relation.id,
                )
              }
            >
              <i className="fa fa-history" />
            </a>
          </CanRead>
        </td>
      </tr>
    </tbody>
  );
};

InvoiceStreamRow.propTypes = {
  invoiceStream: PropTypes.shape({}).isRequired,
  handleSelect: PropTypes.func.isRequired,
  onUpdateAmount: PropTypes.func.isRequired,
  showAssignments: PropTypes.bool,

  intl: intlShape.isRequired,
};
InvoiceStreamRow.defaultProps = {
  showAssignments: false,
};

export default InvoiceStreamRow;
